/* Daro header - mobile menu, live search results, cart count badge. */
(function () {
  document.querySelectorAll('.daro-header').forEach(function (root) {
    initMenu(root);
    initSearch(root);
    initCartCount(root);
  });

  /* ---------- Mobile menu ---------- */
  function initMenu(root) {
    var btn = root.querySelector('.hd-burger');
    if (!btn) return;

    function setOpen(open) {
      root.classList.toggle('is-menu-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.setAttribute('aria-label', open ? 'Close menu' : 'Menu');
    }

    btn.addEventListener('click', function () {
      setOpen(!root.classList.contains('is-menu-open'));
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-menu-open')) {
        setOpen(false);
        btn.focus();
      }
    });
    document.addEventListener('click', function (e) {
      if (root.classList.contains('is-menu-open') && !root.contains(e.target)) setOpen(false);
    });
    window.matchMedia('(min-width: 901px)').addEventListener('change', function (mq) {
      if (mq.matches) setOpen(false);
    });
  }

  /* ---------- Live search (Shopify predictive search JSON) ---------- */
  function initSearch(root) {
    var form = root.querySelector('[data-hd-search]');
    if (!form) return;
    var input = form.querySelector('input[name="q"]');
    var panel = form.querySelector('.hd-results');
    var url = form.getAttribute('data-suggest-url') || '/search/suggest';
    var money;
    try {
      money = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: form.getAttribute('data-currency') || 'USD',
      });
    } catch (e) {
      money = { format: function (n) { return '$' + Number(n).toFixed(2); } };
    }
    var timer, controller, lastQuery = '', dismissed = false;

    function close() {
      panel.hidden = true;
    }

    function el(tag, cls, text) {
      var node = document.createElement(tag);
      if (cls) node.className = cls;
      if (text != null) node.textContent = text;
      return node;
    }

    function thumb(src) {
      if (!src) return '';
      try {
        var u = new URL(src, location.origin);
        u.searchParams.set('width', '96');
        return u.toString();
      } catch (e) {
        return src;
      }
    }

    function render(query, products) {
      panel.textContent = '';
      if (products.length) {
        panel.appendChild(el('p', 'hd-results-label', 'Products'));
        products.forEach(function (p) {
          var a = el('a', 'hd-result');
          a.href = p.url;
          var img = el('span', 'hd-result-img');
          if (p.image) {
            var i = el('img');
            i.src = thumb(p.image);
            i.alt = '';
            i.width = 44;
            i.height = 44;
            i.loading = 'lazy';
            img.appendChild(i);
          }
          var text = el('span');
          if (p.vendor) text.appendChild(el('span', 'hd-result-vendor', p.vendor));
          text.appendChild(el('span', 'hd-result-title', p.title));
          a.appendChild(img);
          a.appendChild(text);
          if (p.price != null) a.appendChild(el('span', 'hd-result-price', money.format(Number(p.price))));
          panel.appendChild(a);
        });
      } else {
        panel.appendChild(el('p', 'hd-results-empty', 'No parts match “' + query + '”'));
      }
      var all = el('a', 'hd-results-all');
      all.href = form.action + '?type=product&q=' + encodeURIComponent(query);
      all.appendChild(el('span', null, 'View all results'));
      all.appendChild(el('span', null, '→'));
      panel.appendChild(all);
      panel.hidden = false;
    }

    function fetchResults(query) {
      if (controller) controller.abort();
      controller = new AbortController();
      var params = new URLSearchParams({
        q: query,
        'resources[type]': 'product',
        'resources[limit]': '6',
        'resources[options][unavailable_products]': 'last',
      });
      fetch(url + '.json?' + params.toString(), { signal: controller.signal })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (input.value.trim() !== query) return;
          render(query, (data.resources && data.resources.results && data.resources.results.products) || []);
        })
        .catch(function () {});
    }

    input.addEventListener('input', function () {
      var query = input.value.trim();
      dismissed = false;
      clearTimeout(timer);
      if (query.length < 2) {
        lastQuery = '';
        if (controller) controller.abort();
        close();
        return;
      }
      if (query === lastQuery) return;
      lastQuery = query;
      timer = setTimeout(function () { fetchResults(query); }, 180);
    });

    input.addEventListener('focus', function () {
      if (!dismissed && panel.childNodes.length && input.value.trim().length >= 2) panel.hidden = false;
    });

    // Arrow keys move between results; Escape closes
    form.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (!panel.hidden) {
          dismissed = true;
          close();
          input.focus();
        }
        return;
      }
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      if (panel.hidden) return;
      var links = Array.prototype.slice.call(panel.querySelectorAll('a'));
      if (!links.length) return;
      e.preventDefault();
      var idx = links.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') idx = idx < links.length - 1 ? idx + 1 : 0;
      else if (idx <= 0) {
        input.focus();
        return;
      } else idx -= 1;
      links[idx].focus();
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) close();
    });
    form.addEventListener('focusout', function (e) {
      if (e.relatedTarget && !form.contains(e.relatedTarget)) close();
    });
  }

  /* ---------- Cart count ---------- */
  function initCartCount(root) {
    var link = root.querySelector('[data-hd-cart]');
    var badge = root.querySelector('.hd-cart-count');
    if (!link || !badge) return;
    var current = parseInt(badge.textContent, 10) || 0;

    function show(count) {
      count = Number(count) || 0;
      badge.textContent = count > 99 ? '99+' : String(count);
      badge.hidden = count === 0;
      link.setAttribute('aria-label', 'Cart, ' + count + (count === 1 ? ' item' : ' items'));
      if (count > current) {
        badge.classList.remove('is-bumped');
        void badge.offsetWidth;
        badge.classList.add('is-bumped');
      }
      current = count;
    }

    function refresh() {
      fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', {
        headers: { Accept: 'application/json' },
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { show(cart.item_count); })
        .catch(function () {});
    }

    // Cart page quantity changes (cart.js) - runs after its own [data-cart-count] update
    document.addEventListener('cart:updated', function (e) {
      var count = e.detail && e.detail.item_count;
      setTimeout(function () {
        if (count != null) show(count);
        else refresh();
      });
    });

    // Add-to-cart, quick add, bulk order (Ella pub/sub)
    // PUB_SUB_EVENTS is a top-level const in constants.js, so it isn't on window
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
        var count = data && data.cartData && data.cartData.item_count;
        if (count != null) show(count);
        else refresh();
      });
    }

    // Back/forward cache can restore a stale count
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) refresh();
    });
  }
})();
